"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _ErrorScreen = require("./ErrorScreen.styles");
var _AlertImage = _interopRequireDefault(require("./AlertImage/AlertImage"));
var _UnsupportedAccounts = _interopRequireDefault(require("../UnsupportedAccounts/UnsupportedAccounts"));
var _constants = require("../../constants");
function ErrorScreen(_ref) {
  var unsupportedAccounts = _ref.unsupportedAccounts,
    changeBank = _ref.changeBank,
    labels = _ref.labels;
  var classes = (0, _ErrorScreen.useStyles)();
  var hasUnsupportedAccounts = function hasUnsupportedAccounts() {
    return unsupportedAccounts && unsupportedAccounts.length > 0;
  };
  var headerText = hasUnsupportedAccounts() ? labels.messageUnsupported : labels.messageNoUnsupported;
  var buttonText = hasUnsupportedAccounts() ? _constants.ERROR_SCREEN_BUTTON_UNSUPPORTED_ACCOUNTS : _constants.ERROR_SCREEN_BUTTON;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container,
    "data-testid": "errorScreen-container"
  }, /*#__PURE__*/_react["default"].createElement(_AlertImage["default"], null), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.alert,
    "data-testid": "errorScreen-title"
  }, _constants.ERROR_SCREEN_TITLE), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.message,
    "data-testid": "errorScreen-message"
  }, headerText), hasUnsupportedAccounts() && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper,
    "data-testid": "unsupported-account-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_UnsupportedAccounts["default"], {
    accounts: unsupportedAccounts
  })), /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
    className: classes.button,
    onClick: changeBank,
    "data-testid": "errorScreen-button"
  }, buttonText));
}
ErrorScreen.propTypes = {
  /**
   * a url used to redirect back to the bank selection page
   */
  changeBank: _propTypes.func.isRequired,
  labels: (0, _propTypes.shape)({
    messageUnsupported: _propTypes.string.isRequired,
    messageNoUnsupported: _propTypes.string.isRequired
  }).isRequired,
  /**
   * collection of accounts NOT supported for ACH transfers
   */
  unsupportedAccounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  }))
};
ErrorScreen.defaultProps = {
  unsupportedAccounts: []
};
var _default = ErrorScreen;
exports["default"] = _default;
